import React from 'react';
import css from 'styled-jsx/css';
import Container from '~/components/Container';
import Config from '~/config';
import themeVariables from '~/shared/themeVariables';
const FAQ = (props) => {
  const { t, lng } = props;
  const faqLink =
    lng === 'tw'
      ? 'https://global.help.freebie-ac.jp/tw/'
      : 'https://global.help.freebie-ac.jp';

  return (
    <Container className={containerClassName}>
      <div className="faq-collections">
        <div className="container-summary">
          <div className="summary-introduce-title">
            <h3
              className="faq-title"
              dangerouslySetInnerHTML={{
                __html: t(Config.getPrefixContent('collections_faq_title')),
              }}
            />
            <a
              className="link-help-page"
              href={faqLink}
              target="_blank"
              rel="noreferrer"
            >
              {t('go_to_help_page')}
            </a>
          </div>

          <div className="summary-content">
            <p
              className="title"
              dangerouslySetInnerHTML={{
                __html: t(
                  Config.getPrefixContent('collections_faq_question_01'),
                ),
              }}
            />
            <div className="content">
              <p
                dangerouslySetInnerHTML={{
                  __html: t('collections_faq_question_01_paragraph_01'),
                }}
              />
              <p
                dangerouslySetInnerHTML={{
                  __html: t('collections_faq_question_01_paragraph_02'),
                }}
              />
              <p
                dangerouslySetInnerHTML={{
                  __html: t('collections_faq_question_01_paragraph_03'),
                }}
              />
              <p
                dangerouslySetInnerHTML={{
                  __html: t('collections_faq_question_01_paragraph_04'),
                }}
              />
              <p
                dangerouslySetInnerHTML={{
                  __html: t('collections_faq_question_01_paragraph_05'),
                }}
              />
            </div>

            <p
              className="title"
              dangerouslySetInnerHTML={{
                __html: t('collections_faq_question_02'),
              }}
            />
            <div className="content">
              <p className="subtitle">{t('main_element')}</p>
              <p
                dangerouslySetInnerHTML={{
                  __html: t('main_element_paragraph_01'),
                }}
              />
              <p
                dangerouslySetInnerHTML={{
                  __html: t('main_element_paragraph_02'),
                }}
              />
              <p
                dangerouslySetInnerHTML={{
                  __html: t('main_element_paragraph_03'),
                }}
              />
            </div>
            <div className="content">
              <p className="subtitle">{t('secondary_element')}</p>
              <p
                dangerouslySetInnerHTML={{
                  __html: t('secondary_element_paragraph_01'),
                }}
              />
              <p
                dangerouslySetInnerHTML={{
                  __html: t('secondary_element_paragraph_02'),
                }}
              />
              <p
                dangerouslySetInnerHTML={{
                  __html: t('secondary_element_paragraph_03'),
                }}
              />
              <p
                dangerouslySetInnerHTML={{
                  __html: t('secondary_element_paragraph_04'),
                }}
              />
              <p
                dangerouslySetInnerHTML={{
                  __html: t('secondary_element_paragraph_05'),
                }}
              />
            </div>

            <p
              className="title"
              dangerouslySetInnerHTML={{
                __html: t(
                  Config.getPrefixContent('collections_faq_question_03'),
                ),
              }}
            />
            <div className="content">
              <p
                dangerouslySetInnerHTML={{
                  __html: t(
                    Config.getPrefixContent(
                      'collections_faq_question_03_paragraph_01',
                    ),
                  ),
                }}
              />
              <p
                dangerouslySetInnerHTML={{
                  __html: t(
                    Config.getPrefixContent(
                      'collections_faq_question_03_paragraph_02',
                    ),
                  ),
                }}
              />
              <p
                dangerouslySetInnerHTML={{
                  __html: t(
                    Config.getPrefixContent(
                      'collections_faq_question_03_paragraph_03',
                    ),
                  ),
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <style jsx>
        {`
          .faq-collections {
            display: flex;
            flex-direction: row;
            justify-content: center;
            flex-wrap: wrap;
            margin: 32px 0;
          }

          .faq-title {
            margin: 0;
            padding: 0;
            font-size: 24px;
            font-weight: 600;
          }

          .summary-introduce-title {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            font-weight: 600;
            font-size: 24px;
          }
          .summary-content {
            display: flex;
            flex-direction: column;
          }
          .title {
            font-weight: bold;
            margin-top: 32px;
          }
          .subtitle {
            font-weight: bold;
          }
          .content {
            margin-top: 16px;
          }
          .link-help-page {
            font-style: normal;
            font-weight: 600;
            font-size: 16px;
            line-height: 28px;
            text-align: center;
            text-decoration: none;
            color: #509bdc;
          }
          .link-help-page:hover {
            text-decoration-line: underline !important;
          }
          @media (max-width: ${themeVariables.breakpoints.mobile.maxWidth}px) {
            .summary-introduce-title {
              display: flex;
              flex-direction: column-reverse;
              align-items: flex-start;
            }

            .summary-content {
              margin-left: 32px;
            }
          }
        `}
      </style>
      {containerStyles}
    </Container>
  );
};
const { className: containerClassName, styles: containerStyles } = css.resolve`
  background: #f8f9fa;
`;

export default FAQ;
